module.exports = __webpack_public_path__ + "img/WALK-COMFORT-A-DROITE.877dec15.svg";